// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1271":"73dfdc18","4386":"e7e03147","7373":"7e132bf5"}[chunkId] + ".chunk.css";
};